'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleReCaptchaProvider as _GoogleReCaptchaProvider } from '@google-recaptcha/react';
import type { ComponentProps } from 'react';
export type ReCaptchaProviderProps = ComponentProps<typeof _GoogleReCaptchaProvider>;
export const GoogleReCaptchaProvider = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <_GoogleReCaptchaProvider {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};